import { render, staticRenderFns } from "./BlockImage.vue?vue&type=template&id=475772fe&"
import script from "./BlockImage.vue?vue&type=script&lang=js&"
export * from "./BlockImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports